<template>
    <div>
        <div class="row d-flex align-items-center mt-5">
            <div class="col-sm-6">
                <h4>Kategorijas</h4>
            </div>
            <div class="col-sm-6 d-flex justify-content-around">
                <CategoriesAdd/>
            </div>
        </div>
        <CategoriesList :hasSearch="true"/>
    </div>
</template>
<script>
    import {mapActions, mapMutations} from 'vuex';
    import * as categoryStoreTypes from '../../vuex/modules/category/category.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';

    import CategoriesList from './CategoriesList';
    import CategoriesAdd from './CategoriesAdd';

    export default {
        name: 'template-categories',
        components: {CategoriesList, CategoriesAdd},
        data: () => ({skeletonData: SkeletonLoaderRepository.usersListLayout}),
        created() {
            this.setTemplate(true);
            this.getCompanies();
        },
        beforeDestroy() {
            this.setTemplate(false);
        },
        methods: {
            ...mapMutations('category', {
                /** @type {function|*} */
                setTemplate: categoryStoreTypes.SET_IS_TEMPLATE,
            }),
            ...mapActions('company', {
                /** @type {function|*} */
                getCompanies: companyStoreTypes.ACTION_GET_COMPANIES,
            }),
        }
    }
</script>